import { privacyPolicyHtml } from '@/assets/html/PrivacyPolicy';

function createMarkup(htmlString: string) {
  return { __html: htmlString };
}

const PrivacyPolicy = () => {
  return <div className="overflow-y-scroll" dangerouslySetInnerHTML={createMarkup(privacyPolicyHtml)} />;
};

export default PrivacyPolicy;
